import { defineAsyncComponent } from 'vue'
export default {
  "components-footer": defineAsyncComponent(() => import("/app/src/layouts/-components/Footer.vue").then(m => m.default || m)),
  "components-header": defineAsyncComponent(() => import("/app/src/layouts/-components/Header.vue").then(m => m.default || m)),
  "components-menu": defineAsyncComponent(() => import("/app/src/layouts/-components/Menu.vue").then(m => m.default || m)),
  "components-preloader": defineAsyncComponent(() => import("/app/src/layouts/-components/Preloader.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/app/src/layouts/default.vue").then(m => m.default || m))
}